<template>
  <div class="logo" id="logo">
    <div class="logo-img">
      <img alt="WangHo logo" src="../assets/imgs/logo.png" />
    </div>
    <div class="logo-text">
      <h2 style="margin-left: 10px;">EFFICIENT</h2>
      <h2 style="margin: 0 5vh;">EXACT</h2>
      <h2>INTELIGENT</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWangHo",
};
</script>
<script setup>

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 95vh;
}

/* 图片的样式 */
img {
  max-width: 390px;
  max-height: 390px;
  border-radius: 50%;
  /* border: 1px solid #d1d9e6; */
  box-shadow: 13px 15px 15px #d1d9e6;
}

img:hover {
  box-shadow: 8px 17px 15px #b4bbc7;
  /* transform: translate(-2px, -2px); */
  /* box-shadow: 7px 7px 7px var(--primary-color); */
}

/* 文字的样式 */
.logo-text {
  margin: 5vh 0 7vh;
  color: var(--secondary-color);
}

h2 {
  font-size: 24px;
  font-style: italic;
  font-weight: bold;
  display: inline-block;
}

h2:hover {
  box-shadow: 5px 5px 5px #d1d9e6;
  transform: scale(1.3);
  transform: translate(-5px, -3px);
  color: var(--primary-color);
}
</style>
